import Trix from 'trix';
import { Controller } from '@hotwired/stimulus';
import { show } from '@frontend/utils/dom';
import { updateReadMoreButtonVisibility } from '@components/comments/comment/component_controller';

export default class extends Controller {
  static targets = ['expandButton', 'comment', 'replyToContainer'];

  connect() {
    this.trixEditor = this.element.querySelector('trix-editor');

    if (this.hasExpandButtonTarget) {
      if (this.commentTargets.length > 1) {
        show(this.expandButtonTarget);
        show(this.commentTargets[this.commentTargets.length - 1]);
      } else {
        this.expand();
      }
    }

    this.element.addEventListener(
      'comments--comment-thread--component:show-all-replies',
      this.handleExpandCommentsInThread.bind(this)
    );
  }

  // NB: For a CSS selector to work, we are removing and not just hiding the button.
  expand() {
    if (this.hasExpandButtonTarget) {
      this.expandButtonTarget.remove();
    }
    this.showAllReplies();
  }

  handleExpandCommentsInThread(event) {
    event.preventDefault();
    event.stopPropagation();

    this.expand();
  }

  showAllReplies() {
    this.commentTargets.forEach((element) => {
      show(element);
      const commentComponent = element.children[0];
      updateReadMoreButtonVisibility(commentComponent);
    });
  }

  replyTo() {
    this.replyToContainerTarget.hidden = false;
    this.trixEditor.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.editor.setSelectedRange(0);
    this.editor.loadHTML('');

    const { userId, userFullName } = event.params;
    const content = `<a class="user-mention" data-controller="user-mention" data-user-mention-user-id-value="${userId}">@${userFullName}</a>`;
    const attachment = new Trix.Attachment({
      content: content,
      contentType: 'inline-element',
    });
    this.editor.insertAttachment(attachment);
    this.editor.insertString(' ');
  }

  resetReplyToForm() {
    this.editor.loadHTML('');
    this.replyToContainerTarget.hidden = true;
    this.element.querySelector('[name="comment[discussion_relation]"]').value =
      '';
    this.element.querySelector('[name="comment[intent]"]').value = '';
  }

  get editor() {
    return this.trixEditor.editor;
  }
}

export function expandCommentsInThread(element) {
  element.dispatchEvent(
    new CustomEvent('comments--comment-thread--component:show-all-replies', {
      bubbles: true,
    })
  );
}
